 var swiper = new Swiper('.swiper-container', {
   slidesPerView: 'auto',
    spaceBetween: 10,
    slidesPerView: 3.5,
        spaceBetween: 20,
    centeredSlides: false,
  freeMode: true, // Enable free mode
  freeModeMomentum: true, // Enable momentum for smooth scrolling
  freeModeSticky: true, // Snap to slides when you end dragging
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 8,
      spaceBetween: 20,
    }
  }
  });